import { useTabContext } from "@/components/TabPanels/TabContext";
import { IconBlock } from "@/libs/builder/blocks/IconBlock";
import cn from "classnames";
import { FC } from "react";

type IconSelectionIdentificatorProps = {
  icons?: string[];
};

export const IconSelectionIdentificator: FC<
  IconSelectionIdentificatorProps
> = ({ icons = [] }) => {
  const { tabs, activeTab, setActiveTab } = useTabContext();
  const visibleIcons = icons.slice(0, tabs.length);

  return (
    <div className="flex flex-row gap-4">
      {visibleIcons.map((icon, index) => (
        <button
          key={index}
          type="button"
          onClick={() => setActiveTab(index)}
          className={cn(
            "p-0.75",
            activeTab === index
              ? "text-swdc-black-600"
              : "text-swdc-warm-gray-175",
          )}
        >
          <IconBlock icon={icon} width={18} height={18} />
        </button>
      ))}
    </div>
  );
};
